import classNames from 'classnames';
import { useId } from 'react';

import { ResponsiveText } from '@farmersdog/corgi-legacy';
import { GridContainer } from '@farmersdog/corgi-x';

import { useRoutes } from '../../static-context';

import { Digest } from './Digest';
import styles from './DigestHighlightsSlice.css';
import { RelatedBreeds } from './RelatedBreeds';
import { getDefaultDigestSlice, getRelatedBreedLinks } from './utils';

import type { DigestHighlightsSliceType } from './types';

export interface DigestHighlightsSliceProps {
  breed?: string;
  slice?: DigestHighlightsSliceType;
  buildId: string;
}

export function DigestHighlightsSlice({
  breed,
  slice,
  buildId,
}: DigestHighlightsSliceProps) {
  const id = useId();

  const digestSliceWithLinks = getDefaultDigestSlice({
    slice,
    buildId,
  });

  const allRoutes = useRoutes();
  const breedLinks = getRelatedBreedLinks({ allRoutes, buildId });

  return (
    <>
      {breed && (
        <section className={styles.section} aria-labelledby={id}>
          <GridContainer>
            <ResponsiveText
              className={classNames(styles.readMore, styles.fullWidth)}
              id={id}
              as="h2"
              variant="heading-3"
              color="kale-3"
            >
              Read more about dog food and {breed}
            </ResponsiveText>
            <Digest breed={breed} slice={digestSliceWithLinks} />
            <RelatedBreeds links={breedLinks} />
          </GridContainer>
        </section>
      )}
    </>
  );
}
